import ComparisonPage, { CompetitorData } from "@/components/marketing/ComparisonPage";

const competitor: CompetitorData = {
  name: "aleno",
  slug: "aleno",
  type: "Solution enterprise / premium",
  hasCommissionPerCover: false,
  hasPriceCeiling: false,
  complexity: "élevée",
  targetAudience: "Grands établissements",
  focus: "Gestion avancée + yield management",
  supportLanguage: "Allemand, Français, Anglais",
  commissionPerCoverChf: "Aucune (modèle par abonnement)",
  countryOfOrigin: "Suisse (Zurich)",
  websiteUrl: "https://www.aleno.me",
  whenToChoose: [
    "Tu gères un restaurant gastronomique ou un hôtel avec des besoins complexes",
    "Tu as besoin de fonctionnalités avancées (yield management, intégrations PMS)",
    "Tu fais partie d'un groupe hôtelier ou d'une chaîne de restaurants",
    "Tu as une équipe IT dédiée pour gérer les intégrations",
    "Ton budget permet un investissement conséquent",
  ],
  pricingDescription:
    "aleno est une solution premium suisse conçue pour les grands établissements. La tarification n'est pas publique : elle est adaptée au cas par cas selon la taille de l'établissement, les modules choisis (yield management, intégrations PMS, CRM) et le volume. Pas de commission par couvert. Demandez un devis personnalisé directement auprès d'aleno.",
  conclusionStrength:
    "les grands établissements, groupes hôteliers ou restaurants gastronomiques avec des besoins de gestion avancés",
  // 11 imp / 0 click mais position 1.5 (excellente). Title joue sur la
  // distinction enterprise (aleno) vs simple/abordable (Piktable).
  seoTitle: "aleno vs Piktable : enterprise complexe ou solution simple ?",
  seoDescription: "aleno cible les grands groupes (yield management, PMS, devis), Piktable s'adresse aux indépendants suisses (forfait fixe, mise en place rapide). Comparatif honnête pour choisir selon ta taille.",
};

const PiktableVsAleno = () => {
  return <ComparisonPage competitor={competitor} />;
};

export default PiktableVsAleno;
